var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.52 4.034c.816.102 1.667.17 2.483.306 1.6.306 2.144 1.123 1.872 2.756-.068.613-.545 1.09-1.157 1.191a4.412 4.412 0 0 1-1.157.068c-5.307 0-10.58.034-15.89.034-.782 0-1.598.067-2.38.204-2.62.408-3.642 1.497-3.846 4.15-.102 1.226-.102 1.226 1.157 1.226H29.31c.34 0 .646.102.952.272.953.612.715 1.6.68 2.484-.033.714-.476 1.123-1.224 1.259-.306.068-.613.068-.953.068H7.125c-.783 0-.783 0-.715.782.034.715.102 1.43.272 2.144.34 1.292 1.123 2.109 2.45 2.483 1.43.408 2.926.476 4.39.51h15.481c.647 0 1.26.068 1.668.68.647 1.021.307 2.349-.714 2.995-.136.102-.272.17-.442.204-1.123.375-2.28.443-3.47.477-4.867.1-9.698.1-14.53-.001a24.52 24.52 0 0 1-4.457-.512c-3.437-.714-5.172-2.484-5.75-5.954-.137-.783-.205-1.6-.307-2.416v-6.33c.068-.611.136-1.258.204-1.87.442-3.913 2.212-5.853 6.057-6.738 1.362-.306 2.79-.374 4.152-.51l15.108.034z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnj);
export default __webpack_public_path__ + "static/media/ENJ.2a8b6582fc31836ee40f58bc0bd7eaf5.svg";
export { ForwardRef as ReactComponent };